import { Component, Input } from '@angular/core';
import { CorrespondenceForm } from '../../forms/correspondence.form';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-correspondence-form',
  standalone: true,
  imports: [
    CommonModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  templateUrl: './correspondence-form.component.html'
})
export class CorrespondenceFormComponent {
  @Input()
  public form: CorrespondenceForm | undefined;
}
